<template>
    <b-row class="event-list">
        <b-col>
            <b-row v-for="event in events" class="event-list-cell" :key="event.id" :id="'Event-'+event.id">
                <b-col cols="12" md="5">
                    <b-carousel :interval="0"
                                :controls="JSON.parse(event.images).length > 1">
                        <b-carousel-slide v-for="image in JSON.parse(event.images)">
                            <template slot="img">
                                <b-container class="event-list-cell-image-wrapper">
                                    <b-img class="event-list-cell-image" :src="HOST + 'static/' + image"></b-img>
                                </b-container>
                            </template>
                        </b-carousel-slide>
                    </b-carousel>
                </b-col>
                <b-col cols="12" md="7" class="event-list-cell-info">
                    <EventDetail :event="event"
                                 :can-enroll="isEventAcceptingEnrollment(event)"
                                 :enrolled="false"
                                 no-border
                                 @enroll="enrollEvent(event)"></EventDetail>
                </b-col>
            </b-row>
        </b-col>

        <b-modal id="enrollmentSuccessModal"
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <b-container class="enrollment-success-container">
                <b-row>
                    <b-col class="enrollment-success-icon">
                        <font-awesome-icon :icon="['far', 'envelope']"></font-awesome-icon>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="enrollment-success-title">
                        {{$t('enrollment_success.title')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{$t('enrollment_success.description')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button class="enrollment-success-close-btn"
                                  @click="$bvModal.hide('enrollmentSuccessModal')">{{$t('close')}}
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </b-row>
</template>

<script>
    import {HOST} from '../main';
    import {DateTime} from 'luxon'
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faDownload} from '@fortawesome/free-solid-svg-icons'
    import {faEnvelope} from '@fortawesome/free-regular-svg-icons'
    import EventDetail from "./EventDetail";

    library.add(faDownload, faEnvelope);

    export default {
        name: 'PreviewEventList',
        components: {EventDetail},
        props: {
            categoryId: String,
        },
        data() {
            return {
                events: [],
                enrollments: {},
                HOST: HOST,
                jumpToEventId: this.$route.query.e,
            };
        },
        mounted() {
            this.getEvents();
        },
        watch: {
            categoryId(newVal) {
                this.events = [];
                this.getEvents();
            },
        },
        computed: {
            enrollmentIds() {
                let enrollmentMap = {};

                this.enrollments.forEach(function (enrollment) {
                    enrollmentMap[enrollment.event.id] = {
                        "-1": enrollment.event.id,
                        "1": enrollment.event.id,
                        "2": enrollment.session ? enrollment.session.id : null,
                        "3": enrollment.series ? enrollment.series.id : null,
                    }[enrollment.event.signup_mode];
                });

                return enrollmentMap
            },
            peopleCountOptions() {
                let options = [];

                for (var i = 1; i <= 10; i++) {
                    options.push({text: i, value: i})
                }

                return options;
            },
        },
        methods: {
            getEvents() {
                let v = this;
                this.$callAPI('hkiarace/event/preview/', {category_id: this.categoryId}, function (response) {
                    this.events = response.body.events;

                    let enrollmentMap = {};

                    response.body.enrollments.forEach(function (enrollment) {
                        if (!(enrollment.event.id in enrollmentMap)) {
                            enrollmentMap[enrollment.event.id] = enrollment;
                        } else if (enrollmentMap[enrollment.event.id].create_at < enrollment.create_at) {
                            // Only keep latest enrollment
                            enrollmentMap[enrollment.event.id] = enrollment;
                        }
                    });

                    this.enrollments = response.body.enrollments;

                    setTimeout(function () {
                        if (v.jumpToEventId) {
                            window.scrollTo(0, document.getElementById('Event-' + v.jumpToEventId).offsetTop);
                        }
                    }, 50);
                });
            },
            eventStatusLabel(event) {
                let eventSignupUntil = DateTime.fromISO(event.signup_until);

                if (eventSignupUntil <= new Date()) {
                    return "(" + this.$t('event_status.enrollment_ended') + ")";
                }

                let eventEnd = DateTime.fromISO(event.end);

                if (eventEnd <= new Date()) {
                    return "(" + this.$t('event_status.ended') + ")";
                }

                if (event.id in this.enrollmentIds) {
                    return "(" + this.$t('event_status.enrolled') + ")";
                }
            },
            eventFeeTiers(event) {
                return JSON.parse(event.fee_tiers || '[]');
            },
            eventDateLabel(event) {
                let date = DateTime.fromISO(event.date);
                let startTime = DateTime.fromISO(event.from_time);
                let endTime = DateTime.fromISO(event.to_time);

                return startTime.toFormat('T') + " - " + endTime.toFormat('T') + ", " + date.toFormat('d/M/y');
            },
            sortedSessions(series) {
                let sessions = Array.from(series.sessions);

                sessions.sort(function (a, b) {
                    if (a.start === b.start) {
                        return 0;
                    }

                    return (a.start > b.start) ? 1 : -1;
                });

                return sessions;
            },
            sessionLabelWithoutName(session) {
                let start = DateTime.fromISO(session.start);
                let end = DateTime.fromISO(session.end);

                return start.toFormat('T') + " - " + end.toFormat('T, d/M/y');
            },
            sessionLabel(session) {
                let start = DateTime.fromISO(session.start);
                let end = DateTime.fromISO(session.end);

                return session.name + ": " + start.toFormat('T') + " - " + end.toFormat('T, d/M/y');
            },
            isEventAcceptingEnrollment(event) {
                return DateTime.fromISO(event.signup_from) < new Date() && new Date() < DateTime.fromISO(event.signup_until);
            },
            eventTimeLabel(event) {
                let fromTime = DateTime.fromFormat(event.from_time, 'HH:mm:ss');
                let toTime = DateTime.fromFormat(event.to_time, 'HH:mm:ss');
                return '';
            },
            eventLanguageLabel(event) {
                let v = this;
                return JSON.parse(event.languages).map(function (l) {
                    return v.$t('languages.' + l);
                }).join(", ")
            },
            downloadPoster(event) {
                window.open('/api/static/' + event.poster, '_blank');
            },
            enrollEvent() {

            },
        },
    }
</script>

<style lang="less">
    .event-list {
        .event-list-cell {
            border: 1px solid #e2e2e2;
            padding: 20px;
            margin-bottom: 1.5rem;

            .event-list-cell-image-wrapper {
                width: 100%;
                padding-top: 127.04837117%;
                position: relative;

                .event-list-cell-image {
                    position: absolute;
                    max-width: 100%;
                    top: 50%;
                    left: 0;
                    transform: translateY(-50%);
                }
            }

            .event-list-cell-info {
                .row {
                    margin-bottom: 15px;
                }

                .event-list-cell-title {
                    font-size: 1.75rem;
                    font-weight: bold;
                    border-bottom: 2px solid;
                    text-align: left;
                }

                .event-list-cell-field-header {
                    font-weight: bold;
                    text-align: left;
                }

                .event-list-cell-field-content {
                    text-align: left;
                }

                .event-list-cell-description {
                    text-align: initial !important;
                    margin-bottom: 72px;
                }

                .event-list-cell-btns {
                    bottom: 15px;
                    right: 15px;

                    button {
                        width: 50%;
                    }

                    .event-list-cell-download-poster-btn {
                        background-color: #f99918;
                        color: white;
                        border: solid 3px #f99918;

                        &:hover {
                            background-color: transparent;
                            color: #f99918;
                        }
                    }

                    .event-list-cell-detail-btn {
                        background-color: black;
                        color: white;
                        font-weight: bold;
                        border: solid 3px black;

                        &:hover {
                            background-color: transparent;
                            color: black;
                        }
                    }
                }
            }
        }
    }

    #enrollmentSuccessModal {
        text-align: center;

        .enrollment-success-container {
            padding-top: 48px;
            font-size: 1.5rem;

            .row {
                margin-bottom: 2rem;
            }

            .enrollment-success-icon {
                font-size: 5rem;
            }

            .enrollment-success-title {
                font-weight: bold;
                font-size: 2.5rem;
            }

            .enrollment-success-close-btn {
                background-color: black;
                border-radius: 0;
                width: 100%;
                font-size: 1.5rem;
            }
        }
    }
</style>